import axiosClient from "../../http-common";

class DevicesApiService {

  getDeviceState(tenantId, containerId, deviceId) {
    return axiosClient.get(`api/v1/tenants/${tenantId}/Containers/${containerId}/Devices/${deviceId}/State`);
  }

  updateDeviceState(tenantId, containerId, deviceId, newState) {
    const futureState = {
      data: newState
    }
    return axiosClient.put(`api/v1/tenants/${tenantId}/Containers/${containerId}/Devices/${deviceId}/State`, futureState);
  }
}

export default new DevicesApiService();